import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3301, { U3301ROLES } from './U3301';
import U3301Agenda from './components/agenda/U3301Agenda';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3301Routes: RouteObject[] = [
  {
    path: 'U3301',
    element: <U2000RequireRole allowedRoles={[U3301ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3301 />,
        children: [{ index: true, element: <U3301Agenda /> }],
      },
    ],
  },
];

export default U3301Routes;
